<template>
  <!-- Pre-program content -->
  <main role="main" class="container">
    <div class="text-center py-md-5 px-md-4 py-3">
      <h1 class="text-uppercase text-center mb-3" v-html="$t('PreProgram.SplashTitle')"> </h1>
      <p v-html="$t('PreProgram.SplashDescription')"></p>     
    </div>
    <h2 class="text-center mb-5">{{ $t('Home.HowToParticipateTitle') }}</h2>
        <div class="row text-center mb-5 d-flex justify-content-center">
          <div class="col-md-6 col-lg-3 home-card-bg">
            <div class="home-card">
              <img
                :src="$t('Home.ShopImg')"
                alt="Shop"
                class="img-fluid mb-3"
              />
              <h4>{{ $t('Home.ShopTitle') }}</h4>
              <p>
                <small v-html="$t('Home.ShopDetail')"></small>
              </p>
            </div>
          </div>

          <div class="col-md-6 col-lg-3 home-card-bg">
            <div class="home-card">
              <img
                :src="$t('Home.SnapImg')"
                alt="Snap"
                class="img-fluid mb-3"
              />
              <h4>{{ $t('Home.SnapTitle') }}</h4>
              <p>
                <small v-html="$t('Home.SnapDetail')"></small>
              </p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 home-card-bg">
            <div class="home-card">
              <img
                :src="$t('Home.SendImg')"
                alt="Send"
                class="img-fluid mb-3"
              />
              <h4>{{ $t('Home.SendTitle') }}</h4>
              <p>
                <small v-html="$t('Home.SendDetail')"></small>
              </p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 home-card-bg">
            <div class="home-card">
              <img
                 :src="$t('Home.RegisterImg')"
                alt="Register"
                class="img-fluid mb-3"
              />
              <h4>{{ $t('Home.RegisterTitle') }}</h4>
              <p>
                <small v-html="$t('Home.RegisterDetail')"></small>
              </p>
            </div>
          </div>
        </div>
  </main>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
  },
};
</script>
<style scoped>
.navbar-nav {
  display: none;
}
</style>
